export const getTextWithoutParagraph = (text) => text.replace(/<\/?p>/g, '');
